module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/pdf-3605161a55789e5db31671ec47813c04.svg";